const __DEV__ = false;

import _defineProperty from '@babel/runtime/helpers/defineProperty';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var mergeDefaultProps = function mergeDefaultProps(passedProps, defaults) {
  var newProps = _objectSpread({}, passedProps);
  Object.keys(defaults).forEach(function (d) {
    var _passedProps$d;
    return newProps[d] = (_passedProps$d = passedProps[d]) !== null && _passedProps$d !== void 0 ? _passedProps$d : defaults[d];
  });
  return newProps;
};
var mergeDefaultProps$1 = mergeDefaultProps;

export { mergeDefaultProps$1 as default };
//# sourceMappingURL=merge-default-props.js.map
